export const createFileLabelFromParts = (...parts: string[]) => parts.join(' ');

export const isNullOrBlank = (testString: string | null): boolean =>
  testString === null || testString === undefined || testString.trim().length === 0;

const LEADING_OR_TRAILING_WHITESPACE_AND_ZERO_WIDTH_CHARS =
  /^[\s\u200B-\u200D\u2060\uFEFF]+|[\s\u200B-\u200D\u2060\uFEFF]+$/g;

export const trimWhitespaceAndZeroWidthChars = (text: string): string =>
  text?.replace(LEADING_OR_TRAILING_WHITESPACE_AND_ZERO_WIDTH_CHARS, '') ?? '';

export const trimAddressString = (text: string | null): string => {
  if (isNullOrBlank(text)) {
    return '';
  }

  return text ? text.trim().replace(/(^,)|(,$)/g, '') : '';
};

export const trimLocationString = (text1: string, text2: string): string => {
  if (isNullOrBlank(text1) && isNullOrBlank(text2)) {
    return '';
  }

  const text1CommasRemoved = text1.trim().replace(/(^,)|(,$)/g, '');
  const text2CommasRemoved = text2.trim().replace(/(^,)|(,$)/g, '');
  return `${text1CommasRemoved}, ${text2CommasRemoved}`;
};

export const capitaliseFirstLetter = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const capitaliseFirstLetterOfEachWord = (text: string) =>
  text.split(/\s+/).map(capitaliseFirstLetter).join(' ');

export const splitCamelCaseIntoWordsAndCapitaliseFirstLetter = (text: string) =>
  text
    .split(/(?=[A-Z])/)
    .map(capitaliseFirstLetter)
    .join(' ');

export const PARAMETER_DELIMITER = '%';

const replaceAll = (text: string, textToReplace: string, replacement: string): string => {
  let result = text.replace(textToReplace, replacement);
  while (result.includes(textToReplace)) {
    result = result.replace(textToReplace, replacement);
  }
  return result;
};

export const replaceTextWithFixedValues = (
  text: string,
  params: Record<string, string>
): string => {
  let replacedText = text;
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const textToReplace = PARAMETER_DELIMITER + key + PARAMETER_DELIMITER;
      replacedText = replaceAll(replacedText, textToReplace, params[key]);
    }
  }
  return replacedText;
};

export const pathToTitle = (path: string) => {
  const trimmedPath = path.replace(/[^a-zA-Z/]/g, ' ');

  const parts = trimmedPath.split('/');

  return parts.map((part) => capitaliseFirstLetter(part)).join(' ');
};
